import { makeStyles } from '@mui/styles';

export const useBackToSearchButtonStyles = makeStyles({
  card: {
    width: '58px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #CCCCCC',
    borderRadius: '5px',
    cursor: 'pointer'
  }
});
